import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCqvQEnXfBbfSJf4bJ66xHDyPO_LYq6Fw8",
    authDomain: "lemontreebooks.web.app",
    databaseURL: "https://lemontreebooks-48817-default-rtdb.firebaseio.com",
    projectId: "lemontreebooks-48817",
    storageBucket: "lemontreebooks-48817.appspot.com",
    messagingSenderId: "865251091660",
    appId: "1:865251091660:web:2e2bc8003abd2765458e69",
    measurementId: "G-2RWHT56C39"
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

export default db;